import type { Reducer } from 'redux';
import { produce } from 'immer';
import type { IncompleteTradeModalState } from '@makemydeal/dr-dash-types';
import {
    SHOW_INCOMPLETE_TRADE_MODAL,
    HIDE_INCOMPLETE_TRADE_MODAL,
    SET_BYPASS_INCOMPLETE_TRADE_CHECK,
    CLEAR_BYPASS_INCOMPLETE_TRADE_CHECK
} from '../types/tradeInTypes';

export type IncompleteTradeModalReducer = Reducer<IncompleteTradeModalState>;

export const initialState: IncompleteTradeModalState = {
    showIncompleteTradeModal: false,
    bypassIncompleteTradeCheck: false
};

export const reducer: Reducer<IncompleteTradeModalState> = (state: IncompleteTradeModalState = initialState, action: any) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case SHOW_INCOMPLETE_TRADE_MODAL:
                draft.showIncompleteTradeModal = true;
                break;
            case HIDE_INCOMPLETE_TRADE_MODAL:
                draft.showIncompleteTradeModal = false;
                break;
            case SET_BYPASS_INCOMPLETE_TRADE_CHECK:
                draft.bypassIncompleteTradeCheck = true;
                draft.showIncompleteTradeModal = false;
                break;
            case CLEAR_BYPASS_INCOMPLETE_TRADE_CHECK:
                draft.bypassIncompleteTradeCheck = false;
                break;
        }
    });
};
